
export default {
  apiKey: "AIzaSyD1VrpvRWBJOtUTr2xmdXjN4D_TP60JdSU",
  authDomain: "blood-pressure-prod.firebaseapp.com",
  databaseURL: "https://blood-pressure-prod.firebaseio.com",
  projectId: "blood-pressure-prod",
  storageBucket: "undefined",
  messagingSenderId: "undefined",
  appId: "1:604839321626:web:dc4333681769b591b631a3",
  measurementId: "G-G491VN9HKS",
}
